<template>
  <div class="modifier-groups">
    <template v-for="group in groups">
      <modifier-portion-group
        v-if="group.type === 'portion'"
        :key="group.modifierGroupId"
        v-bind="getSharedProps(group)"
        @selected="modifiersSelectedHandler"
      />

      <modifier-select-group
        v-else-if="group.modifierGroupTemplate === 'Dropdown' && !readOnly"
        :key="group.modifierGroupId"
        v-bind="getSharedProps(group)"
        @selected="modifiersSelectedHandler"
      />

      <modifier-group-selection
        v-else
        :key="group.modifierGroupId"
        v-bind="getSharedProps(group)"
        @selected="modifiersSelectedHandler"
      />
    </template>
  </div>
</template>

<script>
  import ModifierGroupSelection from '@/components/globals/modifier-group-selection.vue';

  export default {
    name: 'ModifierGroups',

    components: {
      ModifierGroupSelection
    },

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    props: {
      groups: {
        type: Array,
        required: true
      },

      hidePrices: {
        type: Boolean,
        default: false
      },

      readOnly: {
        type: Boolean,
        default: false
      },

      /**
       * The modifiers that have been selected for an order item in the cart.
       * This is used to set the modifier selection states when editing an order item.
       */
      selectedModifiers: {
        type: Array,
        default: null
      }
    },

    data() {
      return {
        groupSelections: {}
      };
    },

    methods: {
      modifiersSelectedHandler(updatedGroup) {
        const existingGroup = this.groupSelections[updatedGroup.modifierGroupId];

        if (existingGroup) {
          existingGroup.modifiers = updatedGroup.modifiers;
        }

        else {
          this.groupSelections[updatedGroup.modifierGroupId] = updatedGroup;
        }

        let allModifiers = [];

        Object.values(this.groupSelections).forEach((group) => {
          allModifiers = allModifiers.concat(group.modifiers);
        });

        this.$emit('selected', allModifiers);
      },

      getSharedProps(group) {
        return {
          hidePrices: this.hidePrices,
          label: group.displayName,
          modifierGroup: group,
          name: `modifier-group-${group.modifierGroupId}`,
          readOnly: this.readOnly,
          selectedModifiers: this.selectedModifiers
        };
      }
    }
  };
</script>
